import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {ScootersIssues} from '../pages/e-commerce/traffic-reveal-card/traffic-reveal-card.component';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IssuesService {

  orgUrl = "";

  constructor(
    private afs: AngularFirestore,
  ) { }

  getIssues() {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<ScootersIssues>('Issues').snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as ScootersIssues;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  addIssues(data) {
    data.Status = 'Pending';
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return new Promise<any>((resolve, reject) => {
      this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.IssuesFromWebCollection).add(data).then( res => {
        console.log('Issue Id',res.id);
        this.editIssue(data, res.id);
      }, err => reject(err));
    });
  }

  getIssueList() {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<any>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.IssuesFromWebCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as ScootersIssues;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  getIssueById(issueId) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.IssuesFromWebCollection).doc(issueId).snapshotChanges().map(actions => {
      const data = actions.payload.data();
      const id = actions.payload.id;
      return { id, ...data };
  });
  }

  getIssueByAsset(AssetDocId) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.IssuesFromWebCollection,ref =>
    ref.where('AssetDocId', '==',AssetDocId)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data();
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  editIssue(data, id) {
    return new Promise<any>((resolve, reject) =>{
      this.orgUrl = localStorage.getItem('currentOrganisation');
      this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.IssuesFromWebCollection).doc(id).update(data).then(res => {}, err => reject(err));
  });
  }

  deleteIssue(issue) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<any>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.IssuesFromWebCollection).doc(issue.id).delete();
  }

}
